<template>
  <i
    :class="ns.b()"
    :style="style"
    data-component-name="Icon"
    data-event-container="true"
    v-bind="$attrs"
  >
    <slot />
  </i>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { addUnit, isUndefined } from '@jdesign-vue/utils'
import { useNamespace } from '@jdesign-vue/hooks'
import { iconProps } from './icon'
import type { CSSProperties } from 'vue'

defineOptions({
  name: 'JdIcon',
  inheritAttrs: false,
})
const props = defineProps(iconProps)
const ns = useNamespace('icon')

const style = computed<CSSProperties>(() => {
  const { size, color } = props
  if (!size && !color) return {}

  return {
    fontSize: isUndefined(size) ? undefined : addUnit(size),
    '--color': props.color,
  }
})
</script>
